import Vue from 'vue'
import Vuex from 'vuex'
import VueRouter from 'vue-router'
import createPersistedState from 'vuex-persistedstate';
import utils from './utils';
import '@/assets/css/tailwind.css'
import App from './App.vue'
import Search from './components/Search.vue';
import SearchResult from './components/SearchResult.vue';

require('spinkit/spinkit.min.css');

Vue.config.productionTip = false
Vue.use(Vuex)
Vue.use(VueRouter)

const numberFormatter = new Intl.NumberFormat('zh-TW');

Vue.filter('numberFormat', function(val) {
    return numberFormatter.format(val);
})

const router = new VueRouter({
    routes: [
        { path: '/', component: Search },
        { path: '/search/:session', component: SearchResult },
        { path: '*', redirect: '/' }
    ]
})

const mutationsShouldNotSave = [
    'setWarningMessages',
    'errorMessages',
    'isLoading',
];

const searchModule = {
    state: {

        cabinClasses: {
            'Economy': '經濟艙',
            // 'PremiumEconomy': '高端經濟艙',
            // 'Business': '商務艙',
            // 'First': '頭等艙',
        },

        warningMessages: [],
        errorMessages: [],

        outboundDateString: null,
        inboundDateString: null,

        originSearch: null,
        originSearchFocused: false,
        originPlacesFiltered: [],

        destinationSearch: null,
        destinationSearchFocused: false,
        destinationPlacesFiltered: [],

        originPlace: null,
        destinationPlace: null,

        formOfTravellerDataFocused: false,
        tripType: 'return',
        cabinClass: 'Economy',
        adults: 1,
        children: [],

        isLoading: false,
    },
    mutations: {
        setWarningMessages(state, messages) {
            state.warningMessages = messages;
        },
        setErrorMessages(state, messages) {
            state.errorMessages = messages;
        },
        setOutboundDate(state, outboundDate) {
            state.outboundDateString = outboundDate instanceof Date ? utils.transformDateToYMD( outboundDate ) : outboundDate;
        },
        setInboundDate(state, inboundDate) {
            state.inboundDateString = inboundDate instanceof Date ? utils.transformDateToYMD( inboundDate ) : inboundDate;
        },
        setOriginSearch(state, text) {
            state.originSearch = text;
        },
        setOriginSearchFocused(state, isFocused) {
            state.originSearchFocused = isFocused;
        },
        setOriginPlacesFiltered(state, places) {
            state.originPlacesFiltered = places;
        },
        setDestinationSearch(state, text) {
            state.destinationSearch = text;
        },
        setDestinationSearchFocused(state, isFocused) {
            state.destinationSearchFocused = isFocused;
        },
        setDestinationPlacesFiltered(state, places) {
            state.destinationPlacesFiltered = places;
        },
        setOriginPlace(state, place) {
            state.originPlace = place;
        },
        setDestinationPlace(state, place) {
            state.destinationPlace = place;
        },
        setFormOfTravellerDataFocused(state, isFocused) {
            state.formOfTravellerDataFocused = isFocused;
        },
        setTripType(state, tripType) {
            state.tripType = tripType;
        },
        setCabinClass(state, cabinClass) {
            state.cabinClass = cabinClass;
        },
        setAdults(state, adults) {
            state.adults = adults;
        },
        setChildren(state, children) {
            state.children = children;
        },
        setIsLoading(state, isLoading) {
            state.isLoading = isLoading;
        },

    },
    actions: {},
    getters: {
        outboundDate(state){
            return state.outboundDateString ? new Date( state.outboundDateString ) : null;
        },
        inboundDate(state){
            return state.inboundDateString ? new Date( state.inboundDateString ) : null;
        },
    },
};

const store = new Vuex.Store({
    modules: {
        search: searchModule,
    },
    strict: true,
    namespaced: true,
    plugins: [createPersistedState({
        filter: (func) => {
            const { type } = func;
            return !~mutationsShouldNotSave.indexOf(type)
        }
    })],
})

new Vue({
    store,
    router,
    render: h => h(App),
}).$mount('#app')
